import { render, staticRenderFns } from "./OnboardingTabText.vue?vue&type=template&id=4f67dacc"
import script from "./OnboardingTabText.vue?vue&type=script&lang=ts"
export * from "./OnboardingTabText.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports